export const camelToSpaces = (str: string): string =>
  str.replace(/([a-z])([A-Z])/g, "$1 $2");

export const camelToCapitalisedWords = (str: string): string =>
  camelToSpaces(str).replace(/(^\w|\s\w)/g, m => m.toUpperCase());
